import { motion } from "framer-motion";

const logos = ["Alpha Corp", "Nexus IO", "Vendly", "FastChat", "CloudOps"];

const SocialProof = () => (
  <section className="py-16 border-t border-b border-warmz-glass-border/20 overflow-hidden">
    <div className="container mx-auto px-4 text-center mb-8">
      <p className="text-sm text-muted-foreground tracking-wide uppercase">
        A proteger a operação das empresas que mais vendem no mercado
      </p>
    </div>
    <div className="relative">
      <div className="flex animate-marquee whitespace-nowrap">
        {[...logos, ...logos].map((name, i) => (
          <motion.div
            key={i}
            className="mx-12 flex items-center justify-center opacity-30 hover:opacity-60 transition-opacity"
          >
            <span className="font-display text-xl font-semibold text-foreground tracking-wide">
              {name}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default SocialProof;
